import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleUp,
  faCircleInfo,
  faCircleQuestion,
  faFile,
  faPaperclip,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAngleDown,
  faAngleUp,
  faCircleInfo,
  faCircleQuestion,
  faFile,
  faPaperclip
);
